/* eslint-disable prefer-destructuring */
import { PrivateSpaceUpdatePatch } from '@weblite/ts-action/private-space'
import { eventBasedSynchronizer } from '$logic/lib/sync/event-based'

const synchronizer = eventBasedSynchronizer<PrivateSpaceUpdatePatch, true>(
  'privateSpaceSync',
  { merge: true },
)

export function set(patch: PrivateSpaceUpdatePatch) {
  return synchronizer.set('me', patch)
}

export async function get() {
  const { items, ...rest } = await synchronizer.getAll()
  return { item: items[0]?.patch, ...rest }
}
